import PropTypes from 'prop-types';
import { Typography, Box, TextField, Accordion, AccordionSummary, Stack } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';

FacilityAddressForm.propTypes = {
  formValue: PropTypes.object,
  setFormValue: PropTypes.func,
  id: PropTypes.string,
  title: PropTypes.string
}

export default function FacilityAddressForm({ formValue, setFormValue, id, title })
{
  const setValue = (field, value) => setFormValue(form => {
    if (!form[id]) form[id] = {};
    form[id][field] = value;
    return { ...form };
  });

  return <Box sx={{ border: "solid thin rgb(43 45 47 / 24%)" }}>
    <Accordion>
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Typography component="span">{title}</Typography>
      </AccordionSummary>
      <Stack sx={{ mx: 2, mb: 2 }} spacing={1} >
        <Box>
          <Typography variant="subtitle1">Street</Typography>
          <TextField
            name="streetAddress"
            size="small"
            placeholder="Enter Street Address"
            fullWidth
            value={formValue[id]?.streetAddress ?? ""}
            onChange={(e) => setValue("streetAddress", e.target.value)}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">City</Typography>
          <TextField
            name="city"
            size="small"
            placeholder="Enter City Address"
            fullWidth
            value={formValue[id]?.city ?? ""}
            onChange={(e) => setValue("city", e.target.value)}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">State</Typography>
          <TextField
            name="state"
            size="small"
            placeholder="Enter State Address"
            fullWidth
            value={formValue[id]?.state ?? ""}
            onChange={(e) => setValue("state", e.target.value)}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">Zip</Typography>
          <TextField
            name="zip"
            size="small"
            placeholder="Enter Zip Address"
            fullWidth
            value={formValue[id]?.zip ?? ""}
            onChange={(e) => setValue("zip", e.target.value)}
          />
        </Box>
        <Box>
          <Typography variant="subtitle1">Phone Number</Typography>
          <TextField
            name="phoneNumber"
            size="small"
            placeholder="Enter Phone Number"
            fullWidth
            value={formValue[id]?.phoneNumber ?? ""}
            onChange={(e) => setValue("phoneNumber", e.target.value)}
          />
        </Box>
      </Stack>
    </Accordion>
  </Box>;
}
